<template>
  <div >
    <div class="list-item" v-for="(item, index) in list" :key="index">
      <div class="item-name flex flex-between pointer" :class="active===item.id?'active':''"  @click="open(item)">
        <el-tooltip class="item" effect="dark" :content=" item.departName" placement="top">
        <span class="text-overflow">{{ item.departName }}</span>
        </el-tooltip>
        <div v-if="item.children && item.children.length">
          <i
            class="el-icon-arrow-right icon-style mr10"
            :class="{ rotate: item.isShow }"
          ></i>
        </div>
      </div>
      <transition name="el-zoom-in-top">
        <div v-if="item.children && item.isShow" class="children-item">
          <side-emp-item :active="active" :list="item.children"></side-emp-item>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
export default {
  name: "SideEmpItem",
  components: {},
  props: {
    list: {
      type: Array
    },
    active: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    open(item) {
      //   this.active = item.id;
      item.isShow = !item.isShow;
      Bus.$emit("check", item);
    }
  }
};
</script>
<style lang='scss' scoped>
.list-item {
  margin-left: 10px;
  .item-name {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    &.active {
      background: #fedeec;
      color: #e50065;
    }
    // padding-left: 10px;
    // padding: 8px 8px 8px 0;
    .el-icon-arrow-right {
      &.rotate {
        transform: rotate(90deg);
        transition: transform 200ms ease-in-out;
      }
    }
  }
}
</style>
